import { SidebarProps } from '../components/Sidebar';

// Sidebar configuration presets
export const sidebarPresets = {
  default: {
    variant: 'default' as const,
    size: 'normal' as const,
  },
  dark: {
    variant: 'dark' as const,
    size: 'normal' as const,
  },
  minimal: {
    variant: 'minimal' as const,
    size: 'normal' as const,
  },
  wide: {
    variant: 'default' as const,
    size: 'wide' as const,
  },
} as const;

export type SidebarPreset = keyof typeof sidebarPresets;

// Utility function to get sidebar configuration
export const getSidebarConfig = (preset: SidebarPreset): Partial<SidebarProps> => {
  return sidebarPresets[preset];
};

// Utility function to create custom sidebar configuration
export const createSidebarConfig = (
  config: Partial<SidebarProps>
): Partial<SidebarProps> => {
  return {
    variant: 'default',
    size: 'normal',
    ...config,
  };
}; 